/** @typedef {import("../types").FiltrosOcorrencia} FiltrosOcorrencia */
/** @typedef {{ commit: Function }} ActionContextRelatoOcorrencia */

/**
 * Ações do store relatoOcorrencia. Geralmente apenas commitam mutações.
 */
export default {
  /**
   * Aplica os filtros no store (reseta a paginação via mutação).
   * @param {ActionContextRelatoOcorrencia} context
   * @param {FiltrosOcorrencia} filtros - filtros a salvar
   */
  setFiltros({ commit }, filtros) {
    commit("SET_FILTROS", filtros);
  },
  limparFiltros({ commit }) {
    commit("RESET_FILTROS");
  },
  /**
   * Define a página atual da listagem.
   * @param {ActionContextRelatoOcorrencia} context
   * @param {number} page
   */
  setPaginaAtual({ commit }, page) {
    commit("SET_PAGINA_ATUAL", page);
  },
  setItensPorPagina({ commit }, size) {
    commit("SET_ITENS_POR_PAGINA", size);
  },
  /**
   * Define o total de registros da listagem.
   * @param {ActionContextRelatoOcorrencia} context
   * @param {number} total
   */
  setTotalRegistros({ commit }, total) {
    commit("SET_TOTAL_REGISTROS", total);
  },
  setLoading({ commit }, loading) {
    commit("SET_LOADING", loading);
  },
  resetarPaginacao({ commit }) {
    commit("RESET_PAGINACAO");
  }
};
